import { RandomFromArray } from "appworks/utils/math/random";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { SymbolWinResult } from "slotworks/model/gameplay/records/results/symbol-win-result";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { DataProcessorSupplement } from "slotworks/model/gameplay/supplements/data-processor-supplement";
import { slotDefinition } from "slotworks/model/slot-definition";

export class ThemePadGridSupplement implements DataProcessorSupplement {
    public active: boolean = true;

    protected paddedReelSize: number = 7;
    protected invalidPaddingSymbols = ["TT", "BN", "WI"];

    public process(record: SpinRecord): void {
        if (!this.active || !record.grid) { return; }

        if (record instanceof FreespinRecord) {
            const offsets: number[] = record.grid.map((reel) => {
                return this.paddedReelSize - reel.length;
            });

            record.grid.forEach((reel, index) => {
                for (let i = 0; i < offsets[index]; i++) {
                    let symbol = "";

                    do {
                        symbol = RandomFromArray(slotDefinition.symbolDefinitions).id;
                    } while (this.invalidPaddingSymbols.find((val) => val === symbol));

                    reel.unshift(symbol);
                }
            });

            record.results.forEach((result) => {
                if (result instanceof SymbolWinResult) {
                    result.positions.forEach((pos) => {
                        pos.y += offsets[pos.x];
                    });
                }
            });
        }
    }
}
